import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/customButtom/CustomButton";

export default function BecomeMentor() {
  const navigate = useNavigate();
  return (
    <div className=" flex items-center justify-center p-8 bg-white m-8 rounded-[30px] border">
      <div className="flex flex-col gap-6">
        <div className="flex justify-center items-center text-2xl md:text-4xl font-bold">
          <p className="text-custom-blue">
            Interested in becoming a
            <span className="text-custom-pink"> Mentor</span>
          </p>
        </div>
        <div>
          <p className="text-border-gray text-sm md:text-base font-normal flex justify-center align-middle">
            Interested in helping others navigate their career transitions in
            the AI era? Join our community of mentors and use your experience to
            make a meaningful impact.
          </p>
          <p className="text-border-gray text-sm md:text-base font-normal flex justify-center align-middle">
            your experience to make a meaningful impact.
          </p>
        </div>
        <div className="flex justify-center">
          <CustomButton
            onClick={() => navigate("/auth/login")}
            label="APPLY TO BE A MENTOR"
          />
        </div>
      </div>
    </div>
  );
}
